import { render, staticRenderFns } from "./recordTable.vue?vue&type=template&id=4dcb031a&"
import script from "./recordTable.vue?vue&type=script&lang=js&"
export * from "./recordTable.vue?vue&type=script&lang=js&"
import style0 from "./recordTable.vue?vue&type=style&index=0&id=4dcb031a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports